import './Views.css'

import React from 'react'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'

export default class Views extends React.Component {
  static contextType = AppContext

  constructor(props) {
    super(props)

    this.state = {}
  }

  switchView(viewId, viewProps = {}) {
    this.setState({
      activeViewId: viewId,
      activeViewProps: viewProps || {},
    })
  }

  render() {
    const View = this.props.views[this.state.activeViewId] || this.props.default
    const switchers = {}

    Object.keys(this.props.views).forEach((key) => {
      switchers[key] = (viewProps) => {
        this.switchView(key, viewProps)
      }
    })

    const { app } = this.context
    const { rooms } = app.data
    const rules = rooms.find((v) => v.roomId === this.props.roomId).rules;

    return (
      <div
        className={classNames('ui-container', {
          transparent: View.backgroundTransparent,
        })}
      >
        <View
          switchView={switchers}
          data={
            this.props.viewData
              ? this.props.viewData[this.state.activeViewId]
              : null
          }
          {...this.state.activeViewProps}
          rules={rules}
          roomId={this.props.roomId}
          tournament={this.props.tournament}
        />
      </div>
    )
  }
}
